
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import { AttributeRequest, Board, Card, CardAttribute, CardAttributeDefinition, CardAttributeDefinitionType, Media, Ticket } from '../../backend/backendapi';
import { KanbanState } from '../kanban.model';
import VueFormAttribute from '../modal/attributes/modal/attribute/VueFormAttribute';
import { handleError } from '../../../api';
import DetailsContent from '../modal/detailscontent/DetailsContent';

@Component({
  components: {
    DetailsContent,
    VueFormAttribute,
  },
})
export default class Public extends Vue {
  @Prop({ required: true })
  cardId!: string;

  //runtime
  readonly state = new KanbanState();
  board: Board | null = null;
  flow: Ticket | null = null;
  card: Card | null = null;

  loaded: boolean = false;

  media: Media[] | null = null;

  error: string | null = null;

  get editableVueFormDefinition(): CardAttributeDefinition | undefined {
    const filtered = this.board?.attributeDefinitions?.filter(e => e.type === CardAttributeDefinitionType.Form && e.metaData?.length)
        .filter(e => JSON.parse(e.metaData!).rcConfig?.publicEdit);
    return (filtered?.length ?? 0) === 1 ? filtered![0] : undefined;
  }

  get hasOneEditableVueForm(): boolean {
    return !!this.editableVueFormDefinition;
  }

  get editableVueFormAttribute(): CardAttribute | undefined {
    if (!this.editableVueFormDefinition || !this.card)
      return undefined;

    this.card.attributes ??= [];
    let attr = this.card.attributes.find(e => e.definitionId === this.editableVueFormDefinition!.id);
    if (!attr) {
      attr = new CardAttribute({ id: 0, cardId: this.card.id!, definitionId: this.editableVueFormDefinition.id, value: '' });
      this.card.attributes.push(attr);
    }
    return attr;
  }

  mounted(): void {
    this.reload();
  }

  async reload(): Promise<void> {
    this.loaded = false;
    this.error = null;
    this.state.cardsAPI.public(this.cardId).then(res => {
      let compound = res.result!;
      this.board = compound.board;
      this.flow = compound.flow;
      this.card = compound.card;

      this.state.boards.splice(0);
      this.state.boards.push(compound.board);

      this.loaded = true;
    }).catch(e => {
      this.error = 'Failed to load card!';
      this.loaded = true;
    });
  }

  async saveVueForm(): Promise<void> {
    if (!this.card || !this.editableVueFormAttribute) {
      return;
    }

    const request = new AttributeRequest({
      cardId: this.cardId,
      attribute: this.editableVueFormAttribute,
    });
    this.state.cardsAPI.updateVueFormAttribute(request).then(res => {
      this.$toasted.info(this.$t('txtSaved').toString());
    }).catch(e => {
      handleError(this.$toasted, this.$i18n, e);
    });
  }

  printScreen(): void {
    window.print();
  }
}
